import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Papa } from 'ngx-papaparse';

@Component({
  selector: 'app-csv-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {

  @Output() onFileParse = new EventEmitter();

  constructor(private papa: Papa) { }

  ngOnInit() {
  }

  onUpload(files: FileList) {
    if(files.length === 0) {
      return;
    }

    const file = files.item(0);
    this.papa.parse(<File><any>file, {
      header: true,
      skipEmptyLines: 'greedy',
      complete: result => {
        this.onFileParse.emit(result);
      }
    });
  }

}
